import { render, staticRenderFns } from "./FoodKindSequence.vue?vue&type=template&id=d4140bc4&"
import script from "./FoodKindSequence.vue?vue&type=script&lang=js&"
export * from "./FoodKindSequence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports